module.exports = __webpack_public_path__ + "static/media/StarIcon.2a9b0834.svg";